const REGION_ID = 'a11y-announcer';

let queue = [];
let flushTimeout;

const targetRegion = () => {
  const modal = document.activeElement?.closest?.('[aria-modal="true"]');
  return modal?.querySelector('[data-announcer]') || document.getElementById(REGION_ID);
};

export function announce(message) {
  if (!message || typeof document === 'undefined') return;

  queue.push(message);
  targetRegion()?.replaceChildren();
  clearTimeout(flushTimeout);
  flushTimeout = setTimeout(() => {
    const region = targetRegion();
    if (!region) {
      queue = [];
      return;
    }
    region.textContent = queue.join('. ');
    queue = [];
  }, 300);
}

export default announce;
